import { useRef } from 'react';
import SomosLandscape from '@/components/Conocenos/SomosLandscape';
import SomosPortrait from '@/components/Conocenos/SomosPortrait';
import Valores from '@/components/Conocenos/Valores';
import Footer from '@/components/Footer';
import useMediaQuery from '@/hooks/useMediaQuery';
import getMetadata from '@/utils/getMetadata';
import { NextSeo } from 'next-seo';
import localeManager from '@/utils/localeManager';
import useLangMenuBar from "@/hooks/useLangMenuBar";

const Conocenos = ({ locale, footer, choose_reasons, about, menu }) => {
  const isLandscape = useMediaQuery('(orientation: landscape)');
  const root = useRef();
  useLangMenuBar(menu)

  return (
    <main ref={root} className="relative site-max mx-auto conocenos">
      <NextSeo
        {...getMetadata({
          locale,
          title: 'Conocenos',
          description:
            'Somos una empresa de tecnología logística orientada a ofrecer la mejor experiencia de entrega y distribución de paquetería. Apasionados por la innovación y la agilidad.',
          pathname: '/conocenos'
        })}
      />
        {/*<Hero />*/}
      {isLandscape ? <SomosLandscape text={about.description} /> : <SomosPortrait text={about.description} />}
      <Valores choose_reasons={choose_reasons} values={about.values} />
      <div className="mask-section">
          {/*<Impacto />*/}
          {/*<Clientes />*/}
      </div>
        <Footer footer={footer} locale={locale} />
    </main>
  );
};

export default Conocenos;

export async function getServerSideProps({ req, locale: nextLocale, defaultLocale }) {
  const { locale, dict } = await localeManager.getLocaleResources(req, {}, nextLocale || defaultLocale);

  return {
    props: {
      locale,
      footer: dict.home.footer,
      choose_reasons: dict.choose_reasons,
      about: dict.about,
      menu: dict.menu
    }
  };
}
